import React from 'react'
import { MdLaptopChromebook } from "react-icons/md";
import { useAccessCard } from '../../ContextProvider/Accesscardprovider'
import { useNavigate } from 'react-router-dom';
import { fetchQuizQuestionData, getResultByStudentId } from '../../Firebase/Course-fb';
import { getUserDocId } from '../../Localstorage';
import { expiryTime, isOlderThan24Hours } from '../../Helper/Calculation';

const Quizcard = () => {

    const { accessCard, accessQuizCard, setTotalTime, setQuestionData, setHead, setQuizCode, setToast } = useAccessCard();

    const { qcode } = useAccessCard()
    const navigate = useNavigate()

    const setWithExpiry = (key, value) => {
        const item = {
            value: value,
        };
        localStorage.setItem(key, JSON.stringify(item));
    };

    const showToast = (msg, type) => {
        setToast({ message: msg, type });
    };

    const startQuiz = async (topic) => {
        console.log(topic)
        const docId = getUserDocId();
        const resultSet = await getResultByStudentId(docId,topic.quiz_code)
        console.log(resultSet)
        if (resultSet!=null && !isOlderThan24Hours(resultSet.time_stamp)) {
            sessionStorage.setItem("quizCode", topic.quiz_code)
            const quizDataToStore = {
                quizTime: resultSet.actual_time / 60,
                quizAnswer: JSON.stringify(resultSet.answer_list),
                quizMarks: resultSet.correct_answered,
                quizTimeLeft: resultSet.time_taken / 60,
                quizHead: resultSet.quiz_name,
                quizQuestions: resultSet.question_list,
            };
            setWithExpiry("Quiz", quizDataToStore);
            const remaining = expiryTime(resultSet.time_stamp)
            const remainingHours = Math.floor(remaining / (60 * 60 * 1000));
            const remainingMinutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));
            accessCard();
            accessQuizCard();
            showToast(`You can take the exam after ${remainingHours}h ${remainingMinutes}m.`, 'warning')
            navigate("/quiz-score");
        } else {
            const questions = await fetchQuizQuestionData(topic.question_code_list);
            setTotalTime(topic.total_time)
            setHead(topic.quiz_name)
            setQuestionData(questions)
            accessCard();
            accessQuizCard();
            sessionStorage.setItem("quizCode", topic.quiz_code)
            sessionStorage.setItem("qquizMarks", 0);
            navigate("/quiz", {
                state: {
                    quiz_code: topic.quiz_code,
                    time: topic.total_time,
                    quizName: topic.quiz_name,
                    questions: questions,
                }
            });
        }
    }

    return (
        <div className='Enroll_course_container'>
            <h3>Quiz</h3>
            <div className='Enroll_course_inner_container'>
                {qcode.map((item, index) => (
                    <div onClick={() => { startQuiz(item); }}>
                        <div className='Enroll_course_card'>
                            <div>
                                <MdLaptopChromebook size={40} className="course_icon" />
                            </div>
                            <div>
                                <span className='quiz-topic'>{item.quiz_name}</span>
                                <div style={{ color: "var(--color-m1)" }} className='quiz-subtopic one'>Total Duration : {item.total_time} Minute</div>
                                <div style={{ color: "var(--color-m1)" }} className='quiz-subtopic two'>Total Question : {item.question_code_list.length}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Quizcard